export const setAllElementsInvisible = state =>
    Object.keys(state).reduce(
        (acc, curr) => ({
            ...acc,
            [curr]: {
                isVisible: false
            }
        }),
        {}
    );
